import { UserData } from '../base-metadata'
import { readSpecialClaims, readUserData } from './metadata-storage'

export class UserPath {
  private readonly userData: UserData
  private readonly specialClaims: string[]

  constructor() {
    this.userData = readUserData()
    this.specialClaims = readSpecialClaims()
  }

  public GetCurrentUserName(): string {
    return this.userData.name as string
  }

  public GetCurrentUser(): string {
    return this.userData.sub as string
  }

  public HasClaim(claimName: string): boolean {
    return !!this.specialClaims.includes(claimName)
  }

  public HasRole(roleName: string): boolean {
    return !!this.userData.role?.includes(roleName)
  }

  public GetClinic(): string {
    return this.userData.business_unit as string
  }

  public GetClinicId(): string {
    return this.userData.business_unit as string
  }
}
